var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DropdownSelectValue',{attrs:{"placeholder":_vm.$t('CultureAgeSelect:Select.Placeholder'),"label":_vm.$t('CultureAgeSelect:Select.Label'),"options":_vm.ages,"disabled":_vm.disabled,"locked":_vm.locked},model:{value:(_vm.ageInput),callback:function ($$v) {_vm.ageInput=$$v},expression:"ageInput"}})
}
var staticRenderFns = []

export { render, staticRenderFns }